<template>
  <div class="search-client-contact-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>Client Contact Search</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <form>
              <div class="form-group">
                <div class="row">
                  <div class="col">
                    <label>Contact Name</label>
                    <input type="text" class="textbox contact-name" v-model="searchOption.name" />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Client Name</label>
                    <input type="text" class="textbox contact-name" v-model="searchOption.ClientName" />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Branch Name</label>
                    <input type="text" class="textbox contact-name" v-model="searchOption.BranchName" />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Is Active</label>
                    <div>
                      <el-select :popper-append-to-body="false" v-model="searchOption.IsActive" placeholder="Is Active" clearable>
                        <el-option :value="1" label="Active">Active</el-option>
                        <el-option :value="0" label="Inactive">Inactive</el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <input type="text" class="textbox hidden-element" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" dark @click="handleModal($event)">Cancel</v-btn>
                    <v-btn dark @click="search">Search</v-btn>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'

export default {
  name: "AdminSearchClientContactModal",
  data() {
    return {
      loadModal: false,

      searchOption: this.initSearchOption(),
    }
  },
  methods: {
    handleModal(e) {
      this.loadModal = !this.loadModal
      if(this.loadModal) {
        $("html").addClass("modal-mask-open")
        setTimeout(() => {
          $('.search-client-contact-modal form').on('keypress', (e) => {
            if (e.keyCode == 13) {
              this.search()
            }
          })
          $('.search-client-contact-modal .contact-name').focus()
        }, 500)
      } else {
        $("html").removeClass("modal-mask-open")
      }
    },
    initSearchOption() {
      return {
        name: "",
        BranchName: "",
        ClientName: "",
        IsActive: null
      }
    },

    async search() {
      if(this.searchOption.name == "") {
        return false
      }

      this.$store.dispatch("loading/setLoadComponent", true)
      if(this.$route.fullPath.includes("/admin-client-contacts")) {
        await this.$parent.$parent.$parent.searchClientContact(this.searchOption)
      } else {
        await utilities.delay(1000)
        this.$router.push({ name: 'admin-client-contacts', params: { searchOptionContactProps: this.searchOption } }).catch((err) => {})
      }
      this.handleModal()
      this.$store.dispatch("loading/setLoadComponent", false)
    },
  },
  beforeMount() {},
  mounted() {},
}
</script>
